import { ScrollSmoother } from '@/lib/gsap';

export const scrollToHash = (hash: string, position: string = 'start'): boolean => {
	const target = document.querySelector(hash);

	if (!target) return false;

	const smoother = ScrollSmoother.get();

	if (smoother) {
		ScrollSmoother.refresh();
		smoother.scrollTo(target, true, position);
	} else target.scrollIntoView({ behavior: 'auto', block: 'start' });

	return true;
};
